import { WizardDialogActionType } from "models/actionTypes/wizardActionTypes";
import { ContextConstants } from "utils/constants";
import { WizardDialogContextState } from "models/propTypes/wizardPropTypes";

export const WizardDialogReducer = (
  state: WizardDialogContextState,
  action: WizardDialogActionType
): WizardDialogContextState => {
  switch (action.type) {
    case ContextConstants.WizardActions.MOVE_NEXT: {
      return { ...state, currentStep: state.currentStep + 1 };
    }
    case ContextConstants.WizardActions.MOVE_PREV: {
      return { ...state, currentStep: state.currentStep - 1 };
    }
    case ContextConstants.WizardActions.SET_CURRENT_STEP: {
      return { ...state, currentStep: action.payload };
    }
    case ContextConstants.WizardActions.SET_NUMBER_OF_STEPS: {
      return { ...state, numOfSteps: action.payload };
    }
    case ContextConstants.WizardActions.SET_WIZARD_FIELDS: {
      return { ...state, wizardFields: action.payload };
    }
    case ContextConstants.WizardActions.SET_CURRENT_STEP_ERRORS: {
      return { ...state, currentStepErrors: action.payload };
    }
    case ContextConstants.WizardActions.SET_VALUES: {
      return { ...state, values: action.payload };
    }
  }
};
